import React from "react";
import { Field } from "react-final-form";
 import { TextFieldAdapter }from "@soqs/common";

const AddressUnitNumber = (props) => {
  let { required, name } = props;

  if (name === undefined) {
    name = "";
  // } else {
   // name = "_" + name;
  }

  if (required === undefined) {
    required = false;
  }
  const isValid = (tel) => {
    const re = /^[0-9a-zA-Z]{0,8}$/;
    return (tel || !required) &&
      (re.test(tel) || (!required && (tel === undefined || tel?.length === 0)))
      ? undefined
      : "Enter a valid unit number";
  };

  const stripSpaces = (value) => {
    return value && value.replace(/ /g, "");
  };
  return (
    <Field
      name={name}
      validate={isValid}
      label="Unit Number"
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      parse={stripSpaces}
      fullWidth
      inputProps={{ maxLength: 8 }}
    />
  );
};

export default AddressUnitNumber;
